import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
            为什么选择黑料视频
          </h2>
          <p className="text-sm text-foreground-500">四大核心优势，让你吃瓜更爽更快更安全</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.id}
              className="group p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/60 cursor-pointer hover:border-accent-200/60 transition-all duration-300"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}